<template>
  <el-card v-if="renderNotDrawer">
    <deal-form-container
      :model="model"
      :is-edit="isEdit"
      :commants="commants"
    />
  </el-card>
  <el-drawer
    v-else
    :title="title"
    :visible.sync="drawer"
    size="85%"
    ref="drawerRef"
    v-loading.fullscreen.lock="loading"
    :with-header="true"
  >
    <deal-form-container
      :model="model"
      :is-edit="isEdit"
      :commants="commants"
    />
  </el-drawer>
</template>

<script>
import Deal from "../../../../models/deals/Deal";
import DealFormContainer from "../../../../components/DealFormContainer.vue";

export default {
  name: "DealFormView",
  components: {
    DealFormContainer
  },
  data() {
    return {
      isEdit: false,
      renderNotDrawer: false,
      title: "",
      drawer: false,
      loading: false,
      model: Deal,
      id: 0,
      activeName: "comments",
      commants: [
        {
          Id: 1,
          Content: "Algun contenido de comentario"
        }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.renderNotDrawer = true;
      this.id = this.$route.params.id;

      this.getData();
    }
  },
  computed: {
    idRoute() {
      return this.$route.params.id;
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get(`/api/deals/GetByID`, {
          params: {
            "criteria.dealID": this.id,
            "criteria.companyID": this.currentCompany
          }
        })
        .then((resp) => {
          this.loading = false;
          this.$store.commit("setSplashScreen", false);
          this.model = resp.data;
          this.title = `Negociacion No. ${resp.data.Id}`;
          this.drawer = true;
        })
        .catch((err) => {
          this.loading = false;
          this.$store.commit("setSplashScreen", false);
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    draw(id) {
      this.id = id;
      this.getData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.deal-footer {
  margin: 1rem;

  table {
    width: 25%;
    border-collapse: collapse;
    border-spacing: 0;

    tr:nth-child(2) td {
      padding-top: 0;
    }
    tr:last-child {
      border-top: 1px solid $text-color-info;
    }

    #total_price {
      font-size: 1.5rem;
      color: $text-color-accent;
    }
  }
}
</style>
